import React, {useState} from "react";
import ReactDOM from 'react-dom/client';
import styled from "styled-components";
import ContactListComponent from "./components/ContactListComponent";
import ConversationComponent from "./components/ConversationComponent";

// this is whats on the app. its a component but the main one. the rest will be imported and rendered.
const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100%;
  background: #f8f9fb;
`;

const ChatPlaceholder = styled.img`
  width: 240px;
  height: 240px;
  border-radius: 50%;
  object-fit: contain;
`;

const Placeholder = styled.div`
  flex: 3;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  gap: 10px;
  span {
    font-size: 32px;
    color: #525252;
  }
`;

function App() {
   const [selectedChat, setChat] = useState();
  return (
  <Container>
    <ContactListComponent setChat={setChat} />
    {selectedChat ? (
    <ConversationComponent selectedChat={selectedChat}/> ) : (<Placeholder>
      <ChatPlaceholder src="/profile/welcome-placeholder.jpeg"/>
      <span>Keep your phone connected</span>
      Whatsapp connects to your phone to sync messages.
      </Placeholder>
    )}
    </Container>
    );
}

export default App;
